import { IMessage } from 'react-stomp-hooks';

import websocketStore from '../../store/WebsocketStore';
import logger from '../../utils/logger.utils';
import { WBlindEvent } from '../events/WBlindEvent';
import { WBotAvailableGameActionEvent } from '../events/WBotAvailableGameActionEvent';
import { WBotErrorEvent } from '../events/WBotErrorEvent';
import { WBotWaitingHostEvent } from '../events/WBotWaitingHostEvent';
import { WBotWaitingHostRebuyEvent } from '../events/WBotWaitingHostRebuyEvent';
import { WCallTimeEvent } from '../events/WCallTimeEvent';
import { WChatEvent } from '../events/WChatEvent';
import { WEvent } from '../events/WEvent';
import { WEventType } from '../events/WEventType';
import { WGameFinishEvent } from '../events/WGameFinishEvent';
import { WLeaveTableEvent } from '../events/WLeaveTableEvent';
import { WMyBotEvent } from '../events/WMyBotEvent';
import { WPlayerEvent } from '../events/WPlayerEvent';
import { WPlayerInitCardsEvent } from '../events/WPlayerInitCardsEvent';
import { WPlayerSitEvent } from '../events/WPlayerSitEvent';
import { WPlayerSittingOutEvent } from '../events/WPlayerSittingOutEvent';
import { WPlayerTurnStartedEvent } from '../events/WPlayerTurnStartedEvent';
import { WRemoveTableEvent } from '../events/WRemoveTableEvent';
import { WTableEvent } from '../events/WTableEvent';
import { WTableSyncEvent } from '../events/WTableSyncEvent';
import { WTableViewerSyncEvent } from '../events/WTableViewerSyncEvent';
import { WTargetEmojiEvent } from '../events/WTargetEmojiEvent';
import { WWaitlistSyncEvent } from '../events/WWaitlistSyncEvent';
import { deserializeWebsocketEvent } from '../utils/w-utils';

const eventClasses: {
  [key in WEventType]?: new (event: WEvent) => WEvent;
} = {
  [WEventType.TABLE_EVENT]: WTableEvent,
  [WEventType.PLAYER_EVENT]: WPlayerEvent,
  [WEventType.PLAYER_SITTING_OUT_EVENT]: WPlayerSittingOutEvent,
  [WEventType.GAME_FINISH_EVENT]: WGameFinishEvent,
  [WEventType.BLIND_EVENT]: WBlindEvent,
  [WEventType.TABLE_SYNC_EVENT]: WTableSyncEvent,
  [WEventType.BOT_EVENT]: WMyBotEvent,
  [WEventType.LEAVE_TABLE_EVENT]: WLeaveTableEvent,
  [WEventType.CHAT_EVENT]: WChatEvent,
  [WEventType.TARGET_CHAT_EVENT]: WTargetEmojiEvent,
  [WEventType.BOT_ERROR_EVENT]: WBotErrorEvent,
  [WEventType.PLAYER_TURN_STARTED_EVENT]: WPlayerTurnStartedEvent,
  [WEventType.PLAYER_INIT_CARDS_EVENT]: WPlayerInitCardsEvent,
  [WEventType.PLAYER_SIT_EVENT]: WPlayerSitEvent,
  [WEventType.REMOVE_TABLE_EVENT]: WRemoveTableEvent,
  [WEventType.CALL_TIME_EVENT]: WCallTimeEvent,
  [WEventType.BOT_AVAILABLE_GAME_ACTION_EVENT]: WBotAvailableGameActionEvent,
  [WEventType.TABLE_VIEWER_SYNC_EVENT]: WTableViewerSyncEvent,
  [WEventType.WAITLIST_SYNC_EVENT]: WWaitlistSyncEvent,
  [WEventType.BOT_WAITING_HOST_EVENT]: WBotWaitingHostEvent,
  [WEventType.BOT_WAITING_HOST_REBUY_EVENT]: WBotWaitingHostRebuyEvent,
};

export class WEventsDispatcher {
  public static handleEvent = async (event: WEvent): Promise<void> => {
    let eventType: WEventType;

    const EventClass = eventClasses[event.eventType];
    if (EventClass) {
      eventType = event.eventType;
      logger.logWEvent(eventType, event);

      await websocketStore.acquireTableLock(event.tableId);

      return new EventClass(event)
        .applyWebsocketChanges()
        .finally(() => websocketStore.releaseTableLock(event.tableId));
    }
    return Promise.reject(new Error('Invalid event type'));
  };

  public static processEventMessage = async (
    message: IMessage,
  ): Promise<void> => {
    const event = deserializeWebsocketEvent(message);
    return this.handleEvent(event);
  };
}
